const mobileQuery = 'screen and (width <= 767px) and (orientation: portrait)';
const tabletQuery = 'screen and (max-height: 800px)';
export const isMobile = () =>{
    return window.matchMedia(mobileQuery).matches;
}
export const isTablet = () =>{
    return window.matchMedia(tabletQuery).matches;
}